module.exports = __webpack_public_path__ + "static/media/io.3ddd1280.svg";